// Alternative search terms for the command menu (Cmd/Ctrl + K), keyed by route URL.
// The page title and its parent sections are already searchable; add synonyms, abbreviations
// and common phrasings here so users can find a page by whatever name they think of.
export const commandMenuKeywords: Record<string, string[]> = {
  // Governance
  '/organisational-context': [
    'org context',
    'organization context',
    'context of the organisation',
    'scope',
    'isms scope',
  ],
  '/policy': ['policies', 'policy register', 'register policy', 'procedures', 'policy list', 'documents', 'add policy'],
  '/exemptions-register': ['exemption', 'exception', 'exceptions register', 'policy exemption', 'waiver'],
  '/manage-projects': ['projects', 'project management', 'tasks', 'task list', 'todo'],
  '/meeting-minutes': ['meetings', 'minutes', 'mom', 'meeting notes'],
  '/service-provider-list': [
    'supply chain register',
    'supplier',
    'suppliers',
    'vendor',
    'vendors',
    'third party',
    'service provider',
    'tprm',
  ],
  '/assessment-library': ['questionnaire', 'vendor questionnaire', 'supplier questionnaire', 'question library'],
  '/service-provider-assessment': ['vendor assessment', 'supplier assessment', 'third party assessment'],
  '/service-provider-incoming-questionnaire': ['incoming', 'received questionnaire', 'customer questionnaire'],
  '/service-provider-report-library': ['vendor report', 'supplier report', 'supply chain report'],
  '/manage-staff': ['staff', 'employees', 'people', 'personnel', 'team members', 'hr'],
  '/document-repo': ['documents', 'files', 'evidence', 'document repository', 'uploads'],
  '/country-regulatory-register-oos': [
    'regulations',
    'regulatory',
    'laws',
    'legal register',
    'legislation',
    'compliance obligations',
  ],
  '/change-management-process': ['change management', 'change request', 'cab', 'changes'],
  '/information-security-objectives': ['objectives', 'iso objectives', 'security goals', 'kpi'],
  '/isms-assurance-calendar': ['calendar', 'assurance calendar', 'schedule', 'audit calendar'],
  '/security-awareness/phished': ['phishing', 'security training', 'awareness training'],
  '/security-awareness/mimecast': ['email security', 'awareness training'],
  '/ai-register': ['ai', 'artificial intelligence', 'ai tools', 'ai systems', 'ai inventory'],

  // Risk
  '/risk-list': ['risks', 'risk register', 'register risk', 'risk list', 'add risk'],
  '/plan-of-action': ['poam', 'poa', 'action plan', 'remediation plan', 'treatment plan'],
  '/risk-assessment': ['sra', 'system risk', 'risk assessment'],
  '/people-risk-assessment': ['pra', 'people risk', 'staff risk', 'people risk assessment'],
  '/information-asset': ['assets', 'asset register', 'register asset', 'asset inventory', 'information assets'],
  '/incident': ['incidents', 'incident register', 'register incident', 'security incident', 'breach'],
  '/risk/vulnerability': ['vulnerabilities', 'vulns', 'cve', 'vulnerability register', 'weakness'],
  '/ctra/programs': ['ctra', 'cyber threat', 'threat assessment programs'],
  '/ctra/zones': ['ctra', 'asset zones', 'zones'],
  '/ctra/engagements': ['ctra', 'engagements'],
  '/ctra/manage-soa': ['ctra', 'soa'],
  '/ctra/threat-scenario': ['ctra', 'threat scenarios', 'scenarios'],

  // Compliance
  '/compliance-report': ['compliance dashboard', 'compliance report', 'compliance overview'],
  '/assessments': [
    'standards',
    'frameworks',
    'iso 27001',
    'soc 2',
    'pci',
    'nist',
    'essential eight',
    'audit',
    'controls',
  ],
  '/archive-assessment': ['archived', 'old assessments', 'past assessments'],
  '/report-library': ['reports', 'compliance reports', 'export'],
  '/issues/non-conformities': [
    'issues',
    'nc',
    'ncr',
    'non conformity',
    'nonconformity',
    'non conformance',
    'findings',
    'corrective action',
    'capa',
    'ofi',
    'opportunity for improvement',
    'improvements',
    'improvement',
  ],
  '/statement-of-applicability': ['soa', 'applicability', 'annex a'],
  // Hidden: '/quarantine-management': ['quarantine', 'quarantined'],

  // Settings
  '/settings/roles-and-permissions': ['roles', 'permissions', 'rbac', 'access control', 'user roles'],
  '/settings/profile': ['my profile', 'account', 'my account'],
  '/settings/mfa': ['2fa', 'two factor', 'multi factor', 'authenticator', 'otp'],
  '/settings/security/sso': ['sso', 'saml', 'single sign on', 'azure ad', 'entra', 'okta'],
  '/settings/security/password-policy': ['password', 'password rules'],
  '/settings/external-integration': ['integrations', 'connectors', 'apps'],
  '/settings/api-tokens': ['api keys', 'tokens', 'access tokens'],
  '/manage-department': ['departments', 'teams', 'business units'],

  // Others
  '/manage-users': ['users', 'invite user', 'add user', 'team', 'members'],
  '/manage-organisation': ['organisation', 'organization', 'company', 'tenant'],
  '/email-logs': ['emails', 'email history', 'sent emails'],
  '/activity-logs/all-users': ['audit log', 'audit trail', 'user activity', 'history'],
  '/login-logs': ['sign in logs', 'login history', 'sessions'],
  '/organisation/resource': ['faq', 'help', 'questions'],
  '/user-manual': ['manual', 'help', 'guide', 'documentation', 'docs'],
  '/bug-report': ['bug', 'feature request', 'feedback', 'support', 'issue'],

  // Admin
  '/admin/organisations': ['organisations', 'organizations', 'tenants', 'customers', 'clients'],
  '/admin/organisation-users': ['users', 'org users'],
  '/admin/subscriptions': ['subscriptions', 'billing', 'plans'],
  '/admin/standards': ['frameworks', 'standards'],
  '/admin/controls': ['controls', 'requirements'],
  '/admin/admins': ['admins', 'administrators', 'super admin'],
  '/admin/signup-request': ['signups', 'registrations', 'new customers'],
}
